import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";
import AlertService from "@/core/services/alert.service";
import router from '@/router'

// action types

export const PAGINATE_ALL_PERIODS = "getPaginatedPeriods";
export const FIND_BY_PERIOD_NAME = "findByPeriodName";
export const ALL_PERIODS = "getAllPeriods";
export const CREATE_PERIOD_FORM = "createPeriodForm";
export const DELETE_PERIOD = "deletePeriod";
export const GET_PERIOD_DATA = "getPeriodData";
export const CREATE_PERIOD = "createPeriod";
export const UPDATE_PERIOD = "updatePeriod";


// mutation types

export const SET_PAGINATED_PERIODS = "setPaginatedPeriods";
export const SET_ALL_PERIODS = "setAllPeriods";
export const SET_PERIOD_DATA = "setPeriodData";
export const SET_PERIOD_META = "setPeriodMeta";
export const SET_PERIOD_ERROR = "setPeriodError";
export const SET_PERIOD_LOADING = "setPeriodLoading";
export const CLEAR_PERIOD_ERROR = "clearPeriodError";
export const SET_IS_DISABLED_PERIOD = "setIsDisabledPeriod";


const state = {
    periods: [],
    paginatedPeriods: [],
    period_data: {},
    meta_period : {
        totalPages: 0,
        total: 0,
        from: 0,
        to: 0,
    },
    errors: [],
    loading: false,
    isDisabled: false
    };

const getters = {
   
    paginateAllPeriods(state) {
        return state.paginatedPeriods;
    },

    allPeriods(state) {
        return state.periods;
    },

    getPeriodData(state) {
        return state.period_data;
    },

    meta_period(state) {
        return state.meta_period;
    },
    
};

const actions = {
 
    [PAGINATE_ALL_PERIODS](context, payload) {
        context.commit(SET_IS_DISABLED_PERIOD, false);
        context.commit(SET_PERIOD_LOADING, true);
        JwtService.getToken();
        ApiService.setHeader();
        ApiService.get(`/periods?size=${payload.itemsPerPage}&page=${payload.pageNumber}&sortBy=${payload.sortBy}&sortDesc=${payload.sortDesc}&searchText=${payload.search}&check=${payload.x}`)
        .then(({ data }) => {
            
            if(data == 403) {
                context.commit(SET_PERIOD_LOADING, false);
                router.push('nopermission');
            }
            else {
                context.commit(SET_PAGINATED_PERIODS, data);
                context.commit(SET_PERIOD_META, data);
                context.commit(SET_PERIOD_LOADING, false);
            }
            
        })
        .catch(( response ) => {
            context.commit(SET_PERIOD_LOADING, false);
            context.commit(SET_PERIOD_ERROR, response.errors);
        });
        ;
        
    },

    [FIND_BY_PERIOD_NAME](context, payload) {
        context.commit(SET_IS_DISABLED_PERIOD, false);
        context.commit(SET_PERIOD_LOADING, true);
        JwtService.getToken();
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.get(`/findByPeriodName?searchText=${payload.searchText}&check=${payload.x}`)
            .then((response) => {
                resolve(response);
            })
        });
    },


    [ALL_PERIODS]() {
        return new Promise(resolve => {
            ApiService.get('/periodsAll')
            .then((response) => {
                resolve(response);
            })
        });
    },

    [CREATE_PERIOD_FORM](context) {
        context.commit(SET_PERIOD_LOADING, false);
        context.commit(SET_PERIOD_ERROR, false);
        context.commit(SET_IS_DISABLED_PERIOD, false);
    },

    [GET_PERIOD_DATA](context, payload) {
        context.commit(SET_IS_DISABLED_PERIOD, true);
        context.commit(SET_PERIOD_LOADING, true);
        context.commit(CLEAR_PERIOD_ERROR);
        return new Promise(resolve => {
            ApiService.get(`/period/${payload.id}`)
            .then(( response ) => {
                if(response.data == 403) {
                    context.commit(SET_PERIOD_LOADING, false);
                    router.push('/nopermission');
                }
                else {
                    context.commit(SET_PERIOD_DATA, response.data);
                    context.commit(SET_PERIOD_LOADING, false);
                    context.commit(SET_IS_DISABLED_PERIOD, false);
                    resolve(response);
                }
            })
            .catch(({ response }) => {
                context.commit(SET_PERIOD_LOADING, false);
                context.commit(SET_PERIOD_ERROR, response.data.errors);
                context.commit(SET_IS_DISABLED_PERIOD, true);
            });
        });
    },

    [CREATE_PERIOD](context, payload) {
        context.commit(SET_PERIOD_LOADING, false);
        context.commit(SET_IS_DISABLED_PERIOD, true);
        context.commit(CLEAR_PERIOD_ERROR);
        return ApiService.post("/period/store", payload.data)
        .then(( response ) => {
            if(response.data == 403) {
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde ekleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                context.commit(CLEAR_PERIOD_ERROR);
            }
            else{
                context.commit(SET_PERIOD_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Kayıt Başarılı",
                    "Dönem başarıyla kaydedilmiştir. ID numarası: " + response.data.id
                );
                context.commit(CLEAR_PERIOD_ERROR);
                context.commit(SET_IS_DISABLED_PERIOD, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                return response;
            }
        })
        .catch(({ response }) => {
            context.commit(SET_PERIOD_LOADING, false);
            context.commit(SET_PERIOD_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_PERIOD, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
        });
    },

    [UPDATE_PERIOD](context, payload) {
        context.commit(SET_PERIOD_LOADING, true);
        context.commit(SET_IS_DISABLED_PERIOD, true);
        context.commit(CLEAR_PERIOD_ERROR);
        
        return ApiService.put(`/period/${payload.data.id}`, payload.data)
        .then((response) => {
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde güncelleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                context.commit(SET_PERIOD_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Güncelleme Başarılı",
                    payload.data.id + " ID numaralı dönem başarıyla güncellenmiştir."
                );
            
                context.commit(SET_IS_DISABLED_PERIOD, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                
            return response;   
            }
                
        })
        .catch(({ response }) => {
            context.commit(SET_PERIOD_LOADING, false);
            context.commit(SET_PERIOD_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_PERIOD, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
            
        });
        
    },

    [DELETE_PERIOD](context, payload) {
        context.commit(SET_PERIOD_LOADING, true);
        context.commit(CLEAR_PERIOD_ERROR);
        JwtService.getToken();
        ApiService.setHeader();
        ApiService.delete(`/period/${payload.itemToDelete}`)
        .then(( response ) => {
            context.commit(SET_PERIOD_LOADING, false);
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde silme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
               
                AlertService.makeToast(
                    "success",
                    "Silme Başarılı",
                    payload.itemToDelete + " ID numaralı dönem başarıyla silinmiştir."
                );
                
            }
        })
        .catch(( error ) => {
            context.commit(SET_PERIOD_ERROR, error);
        });
        
    },

    
    
};

const mutations = {

    [SET_PAGINATED_PERIODS](state, paginatedPeriods) {
        state.paginatedPeriods = paginatedPeriods.data;
    },

    [SET_ALL_PERIODS](state, periods) {
        state.periods = periods;
    },

    [SET_PERIOD_DATA](state, periods_data) {
        state.periods_data = periods_data;
        state.errors = [];
    },

    [SET_PERIOD_META](state, meta_period) {
        state.meta_period = meta_period;
    },

    [SET_PERIOD_ERROR](state, error) {
        state.errors = error;
    },

    [CLEAR_PERIOD_ERROR](state) {
        state.errors = [];
    },
    
    [SET_PERIOD_LOADING](state, loading) {
        state.loading = loading;
    },

    [SET_IS_DISABLED_PERIOD](state, isDisabled) {
        state.isDisabled = isDisabled;
    },

};

export default {
    state,
    actions,
    mutations,
    getters
};
